import { MsgBox } from "./update-message.styled";

export const UpdateMessage = (props) => {
  const { children, ...rest } = props;
  return (
    <MsgBox {...rest}>
      <img src="/images/success_transparent.png" alt="" />
      <p>{children}</p>
    </MsgBox>
  );
};
